import { useReducer } from 'react';
import { EDashboardBookingStatus, ESalesMetricsGroupBy, ISalesMetricsFilters } from 'services/DashboardApi/types';

const initialStatuses: EDashboardBookingStatus[] = [EDashboardBookingStatus.REQUESTED, EDashboardBookingStatus.CONFIRMED, EDashboardBookingStatus.COMPLETED];

export enum ESalesMetricsFiltersAction {
  SET_DATE_TYPE = 'SET_DATE_TYPE',
  SET_STATUS = 'SET_STATUS',
  SET_COMPANY_COUNTRY = 'SET_COMPANY_COUNTRY',
  SET_COMPANY = 'SET_COMPANY',
  SET_DESTINATION = 'SET_DESTINATION',
  SET_HOTEL = 'SET_HOTEL',
  RESET_FILTERS = 'RESET_FILTERS',
}

export type ISalesMetricsFiltersAction =
  | { type: ESalesMetricsFiltersAction.SET_DATE_TYPE; payload: ESalesMetricsGroupBy }
  | { type: ESalesMetricsFiltersAction.SET_STATUS; payload: EDashboardBookingStatus[] }
  | { type: ESalesMetricsFiltersAction.SET_COMPANY_COUNTRY; payload: string[] }
  | { type: ESalesMetricsFiltersAction.SET_COMPANY; payload: string[] }
  | { type: ESalesMetricsFiltersAction.SET_DESTINATION; payload: string[] }
  | { type: ESalesMetricsFiltersAction.SET_HOTEL; payload: string[] }
  | { type: ESalesMetricsFiltersAction.RESET_FILTERS };

const initialFilterState: ISalesMetricsFilters = {
  dateType: ESalesMetricsGroupBy.CREATION_DATE,
  status: initialStatuses,
  companyCountry: [],
  company: [],
  destination: [],
  hotel: [],
};

const salesMetricsFiltersReducer = (state: ISalesMetricsFilters, action: ISalesMetricsFiltersAction): ISalesMetricsFilters => {
  switch (action.type) {
    case ESalesMetricsFiltersAction.SET_DATE_TYPE:
      return { ...state, dateType: action.payload };
    case ESalesMetricsFiltersAction.SET_STATUS:
      return { ...state, status: action.payload };
    case ESalesMetricsFiltersAction.SET_COMPANY_COUNTRY:
      return { ...state, companyCountry: action.payload, company: [] };
    case ESalesMetricsFiltersAction.SET_COMPANY:
      return { ...state, company: action.payload };
    case ESalesMetricsFiltersAction.SET_DESTINATION:
      return { ...state, destination: action.payload, hotel: [] };
    case ESalesMetricsFiltersAction.SET_HOTEL:
      return { ...state, hotel: action.payload };
    case ESalesMetricsFiltersAction.RESET_FILTERS:
      return initialFilterState;
    default:
      return state;
  }
};

export const useSalesMetricsFiltersReducer = () => {
  const [filters, dispatchFilters] = useReducer(salesMetricsFiltersReducer, initialFilterState);

  return {
    filters,
    dispatchFilters,
  };
};
